export default "__VITE_ASSET__2047b977__"